<div class="px-3 sm:px-0">
  <div class="mt-2 border">
    <soft-rich-text-editor
      [content]="editorContent() || ''"
      [features]="['font-format']"
      class="block min-h-[30vh]"
      #editor
    >
    </soft-rich-text-editor>
  </div>
</div>

<div class="flex flex-row flex-nowrap mt-4">
  <button class="soft-button secondary fill-force" (click)="resolve(null)">
    {{ '#WORK_NOTE.DIALOGS.SIGNATURE.CANCEL_BTN' | translate }}
  </button>
  <button
    class="soft-button primary fill-force"
    (click)="save(editor?.getContent() ?? '')"
    [disabled]="isSaving"
  >
    <span>
      @if (isSaving) {
        <i class="fa-regular fa-spinner fa-spin"></i>
      }
      {{ '#WORK_NOTE.DIALOGS.SIGNATURE.SAVE_BTN' | translate }}
    </span>
  </button>
</div>
